import React from "react";
import styles from "./TableItem.module.scss";
import classNames from "classnames";
import Button from "../Button/Button";
import UploadFile from "../UploadFile/UploadFile";
import {TiposArchivoPermitidos} from "../../../util/Constants";

export interface TableItemProps {
  id: string;
  title: string;
  estado?: "RECHAZADO" | "ENVIADO" | "APROBADO" | "ALMACENADO" | "RECIBIDO";
  observaciones?: string;
  fechaCarga?: string;
  button?: boolean;
  buttonProps?: TableItemButtonProps;
  buttonOp?: boolean;
  buttonOpProps?: TableItemButtonOpProps;
  hoverButtons?: boolean;
  onUploadCancel?: React.EventHandler<any>;
  onUploadConfirm?: React.EventHandler<any>;
}

export interface TableItemButtonProps {
  id: string;
  name: string;
  disabled?: boolean;
  loader?: boolean;
  icon?: string;
  onClick?: React.MouseEventHandler<any>;
  text: string;
}

export interface TableItemButtonOpProps {
  id: string;
  name: string;
  disabled?: boolean;
  loader?: boolean;
  icon?: string;
  onClick?: React.MouseEventHandler<any>;
  text: string;
}

const estadoR = "RECHAZADO";
const estadoE = "ENVIADO";
const estadoA = "APROBADO";
const estadoAl = "ALMACENADO";
const estadoRE = "RECIBIDO";

class TableItem extends React.Component<TableItemProps, any> {

  constructor(props: any) {
    super(props);
    this.state = {
      width: window.innerWidth,
      responsive: false,
      showHoverButtons: false,
    };
    this.updateDimensions = this.updateDimensions.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
  }

  componentWillMount() {
    if (this.state.width <= 576) {
      this.setState({responsive: true});
    }
    window.addEventListener("resize", this.updateDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions);
  }

  updateDimensions() {
    this.setState({
      width: window.innerWidth
    });
    if (this.state.width <= 576) {
      this.setState({responsive: true});
    } else {
      this.setState({responsive: false});

    }
  }

  onMouseEnter() {
    if (this.isHoverButtonBoxEnabled()) {
      this.setState({showHoverButtons: true});
    }
  }

  onMouseLeave() {
    if (this.isHoverButtonBoxEnabled() && !this.areThereOpenDialogs()) {
      this.setState({showHoverButtons: false});
    }
  }

  areThereOpenDialogs() {
    const dialogs = document.getElementsByClassName("sweet-alert");
    return dialogs && dialogs.length > 0;
  }

  isHoverButtonBoxEnabled() {
    return (this.props.hoverButtons && (this.props.buttonProps || this.props.buttonOpProps));
  }

  render() {

    let bulletStyle;
    if (this.props.estado === estadoR) {
      bulletStyle = {backgroundColor: "red"};
    } else if (this.props.estado === estadoE || this.props.estado === estadoAl || this.props.estado === estadoRE) {
      bulletStyle = {backgroundColor: "#00aecb"};
    } else if (this.props.estado === estadoA) {
      bulletStyle = {backgroundColor: "#97d700"};
    }

    return (
      <>
        {!this.state.responsive &&
        <div className={classNames("row", styles.RowContainer)}
             onMouseEnter={this.onMouseEnter}
             onMouseLeave={this.onMouseLeave}>

          <div className={styles.ChildrenRows}>

            <div className="col-4">
              <label className={styles.LabelMedium}>{this.props.title}</label>
            </div>

            <div className="col-4">
              <label className={styles.LabelMedium}>{this.props.observaciones}</label>
            </div>

            <div className="col-2">
              <label className={styles.LabelMedium}>{this.props.fechaCarga}</label>
            </div>

            <div className="col-2">
              <div id="bullet" className={styles.Bullet} style={bulletStyle}/>
              <label className={styles.LabelMedium}>{this.props.estado}</label>
            </div>

            {(this.props.hoverButtons && this.state.showHoverButtons) &&
            <div className={styles.HoverBox}>
              {(this.props.buttonOpProps && this.props.buttonOp) &&
              <UploadFile id={this.props.id}
                          buttonText={this.props.buttonOpProps.text}
                          documentTitle={this.props.title}
                          allowedMimeTypes={TiposArchivoPermitidos}
                          maxSizeInMB={8}
                          onCancel={this.props.onUploadCancel}
                          onConfirm={this.props.onUploadConfirm}
                          buttonNoFullWidth
                          buttonTypeStyle={"ghost"}>
                <img className={styles.ButtonImg}
                     src={require(`../../../assets/img/icons/${this.props.buttonOpProps.icon}.svg`)}
                     alt={this.props.buttonOpProps.text}/>
              </UploadFile>
              }

              {(this.props.button && this.props.buttonProps) &&
              <Button id={this.props.buttonProps.id}
                      type={"button"}
                      name={this.props.buttonProps.name}
                      onClick={this.props.buttonProps.onClick}
                      typeStyle={"ghost"}
                      notFullWidth>
                <img className={styles.ButtonImg}
                     src={require(`../../../assets/img/icons/${this.props.buttonProps.icon}.svg`)}
                     alt={this.props.buttonProps.text}/>
                {this.props.buttonProps.text}
              </Button>
              }

            </div>
            }
          </div>
        </div>
        }

        {this.state.responsive && this.props.buttonProps &&
        <>
          <li className={classNames(styles.TableItem)} id={"LI" + this.props.id}>

            <div className={styles.TableGrid}>

              <div className={styles.TitleGrid}>
                <span id="title" className={styles.Title}>{this.props.title}</span>
              </div>
            </div>

            <div className={styles.TableSmallContainer}>

              <div className={styles.RowTable}>
                <div className="col-5">
                  <label className={styles.LabelBig}>Observaciones:</label>
                </div>
                <div className="col-7">
                  <label className={styles.LabelMedium}>{this.props.observaciones}</label>
                </div>
              </div>

              <div className={styles.RowTable}>
                <div className="col-5">
                  <label className={styles.LabelBig}>Fecha de carga:</label>
                </div>
                <div className="col-7">
                  <label className={styles.LabelMedium}>{this.props.fechaCarga}</label>
                </div>
              </div>

              <div className={styles.RowTable}>
                <div className="col-5">
                  <label className={styles.LabelBig}>Estado:</label>
                </div>
                <div className="col-7">
                  <label className={styles.LabelEstado}>
                    <div id="bullet" className={styles.Bullet} style={bulletStyle}/>
                    {this.props.estado}
                  </label>
                </div>
              </div>

            </div>
            {this.props.estado === "RECHAZADO" &&
            <div className={styles.ButtonContainer}>
              <UploadFile id={this.props.id}
                          buttonText="Reemplazar archivo"
                          documentTitle={this.props.title}
                          allowedMimeTypes={TiposArchivoPermitidos}
                          maxSizeInMB={8}
                          onCancel={this.props.onUploadCancel}
                          buttonTypeStyle={"primary"}
                          buttonNoFullWidth/>
            </div>
            }
            <div className={styles.ButtonContainer}>
              {(this.props.button && this.props.buttonProps) &&
              <Button type={"button"}
                      name={this.props.buttonProps.name}
                      onClick={this.props.buttonProps.onClick}
                      typeStyle={"ghost"}
                      notFullWidth>
                {this.props.buttonProps.text}
              </Button>}
            </div>
          </li>
        </>}
      </>
    );
  }

}

export default TableItem;
